import clsx from 'clsx';
import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  value: number;
  variant: 'blue' | 'green' | 'red' | 'yellow';
}

const ProgressBar = ({ value, variant }: ProgressBarProps) => {
  return (
    <div className={clsx('d-flex flex-row align-items-center', styles.container)}>
      <div className={clsx(styles.bar, styles[variant])} style={{ width: `${value}%` }} />
    </div>
  );
};

export default ProgressBar;
